import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { GET_TIME_PROFILES } from '../get-time-profiles';
import { useModal } from '../../../../store/modals';
import { createTimeProfilesAPI } from './api';

export function useCreateTimeProfile(onSuccess) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation((timeProfile) => createTimeProfilesAPI(timeProfile), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_TIME_PROFILES, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: {
          type: 'success',
          description: 'timeProfileCreatedSuccessfully',
        },
      });
      if (onSuccess) onSuccess();
    },
    onError: (error) => {
      if (error?.errorMessage?.includes('already exists')) {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'timeProfileAlreadyExists',
          },
        });
      } else {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      }
    },
  });

  return {
    ...mutation,
  };
}

